import React                      from 'react';
import TableCell                  from '@mui/material/TableCell';
import TableRow                   from '@mui/material/TableRow';
import { IconButton }             from '@mui/material';
import DeleteForeverOutlinedIcon  from '@mui/icons-material/DeleteForeverOutlined';
import {useCatalogCartItemRemove} from '../../../../hooks/api/catalog/cart/useCatalogCart';

const CartItem = ({ cartItem, refreshCart = null }) => {
	const [remove, removing] = useCatalogCartItemRemove(cartItem.key);

	const handleDelete = () => {
		remove().then(refreshCart);
	};

	return (
		<TableRow>
			<TableCell>{cartItem.data['Basic.Name']}</TableCell>
			<TableCell>{cartItem.quantity}</TableCell>
			<TableCell>{cartItem.price.raw.display}</TableCell>
			<TableCell>{`${cartItem.price.tax_rate}%`}</TableCell>
			<TableCell>{cartItem.price.tax.display}</TableCell>
			{refreshCart && <TableCell align='right'>
				<IconButton
					onClick={handleDelete}
					size='small'
					disabled={removing}
					color='secondary'
				>
					<DeleteForeverOutlinedIcon/>
				</IconButton>
			</TableCell>
			}
		</TableRow>
	);
};

export default CartItem;